import { useQuery } from "@apollo/client";
import { ATTRIBUTE_VENDOR_COUNT_QUERY } from "./queries";
import { NumberCard } from "../components/NumberCard";
import { TAXONOMY_CLIENT } from "../../../utils/consts";

export const VendorCountCard = (props: { attributeId: number }) => {
  const { data, loading } = useQuery(ATTRIBUTE_VENDOR_COUNT_QUERY, {
    variables: {
      attributeId: props.attributeId,
    },
    skip: props.attributeId === 0,
    context: {
      clientName: TAXONOMY_CLIENT,
    },
  });

  return (
    <NumberCard
      id="vendor-count"
      isLoading={loading}
      count={data?.vendor.count || 0}
      title="Number of Vendors"
    />
  );
};
